.meetingForm {
  --primary-color: #154dd1;
  --primary-border-color: #154dd1;
  --primary-text-color: #fff;
  --primary-hover-color: #193f99;
  --primary-hover-border-color: #193f99;
  --primary-hover-text-color: #fff;
  --primary-background-input-field-color: #e6eff6;
  --primary-placeholder-color: #9fa9bc;
  --primary-border-focus-color: #075da7;
  --primary-cta-color: #e30613;

  --secondary-color: #154dd1;
  --secondary-border-color: #e6eff6;
  --secondary-text-color: #002b4d;
  --secondary-hover-color: #193f99;
  --secondary-hover-border-color: #193f99;
  --secondary-hover-text-color: #fff;

  font-size: 16px;
  padding: 0 32px 40px 32px;
  background-color: var(--primary-text-color);
  border-radius: 8px;
  opacity: 1;
  transition: all 0.2s linear;
}

.action {
  flex: 1 1 50%;
  position: relative;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  font-family: "CornerDisplay", sans-serif;
  color: var(--form-text-color);
}

.meetingForm h3 {
  font-size: 18px;
  font-weight: 500;
  margin: 12px 0 -12px 0;
  line-height: 1.31;
  color: var(--secondary-text-color);
}

.meetingTitle {
  font-size: 40px;
  font-weight: 500;
  word-wrap: break-word;
  line-height: 1.1;
  margin-top: 32px;
  text-align: left;
}

.meetingTitle .hlight {
  color: var(--primary-border-focus-color);
}

.meetingSubTitle {
  color: var(--form-text-info-color);
  font-size: 20px;
  font-weight: 200;
  line-height: 1.27;
  margin: 16px auto 24px;
  text-align: left;
}

div.customRadio > label {
  padding-left: 48px;
}

div.customRadio label:focus-within {
  border: solid 1px var(--secondary-border-color);
}

div.customInputCalendar {
  cursor: pointer;
  border: none;
  background-color: var(--primary-background-input-field-color);
}

div.customInputCalendar i {
  display: none;
  align-self: center !important;
  color: var(--ternary-color-80) !important;
  margin-left: 50px !important;
  position: absolute;
  right: 12px;
}

div.customInputCalendar label {
  line-height: 1.5 !important;
  top: 0 !important;
  left: 16px !important;
  cursor: pointer;
}

div.customInputCalendar input {
  margin-top: 17px;
  border: none;
  font-size: inherit;
  max-width: 220px;
  background-color: var(--primary-background-input-field-color);
  color: var(--secondary-text-color);
}

div.customInputCalendar:focus-within > input,
div.customInputCalendar:focus-within > div > input {
  background-color: var(--primary-text-color);
}

div.customFieldRow {
  margin: 0 -6px;
  display: flex;
  flex-direction: column;
}

div.customPhoneInput > div,
div.customPhoneInput > div > input[type="text"] {
  width: 80px !important;
}

div.customPhoneInput,
div.customInput {
  border: none;
  border-radius: 8px;
  background-color: var(--primary-background-input-field-color);
}

/* div.customPhoneInput > input::placeholder,
div.customInput > input::placeholder {
  color: var(--primary-placeholder-color);
}

div.customPhoneInput > input:focus::placeholder,
div.customInput > input:focus::placeholder {
  opacity: 0;
} */

div.customPhoneInput:focus-within,
div.customInput:focus-within,
div.customInputCalendar:focus-within {
  border: solid 2px var(--secondary-border-color);
  background-color: var(--primary-hover-text-color);
}

div.customPhoneInput > div > input,
div.customInput > input,
div.customInput > input[type="text"] {
  color: var(--secondary-text-color);
}

div.customPhoneInput > div > div > div > div,
div.customInput > div > div > div,
div.customInputCalendar > div > div > div,
div.customRadio {
  font-family: "Inter", sans-serif;
}

label.customLabel {
  display: block;
  margin-bottom: 8px;
  font-weight: 700;
  color: var(--secondary-text-color);
  font-size: 12px;
  font-family: "CornerDisplayBolder", sans-serif;
  text-transform: uppercase;
}

label.customLabel:has(+ .customPhoneInput:focus-within),
label.customLabel:has(+ .customInput:focus-within),
label.customLabel:has(+ .customInputCalendar:focus-within) {
  color: var(--primary-border-focus-color);
}

div.customPhoneInput > div > i,
div.customInput > i {
  display: none;
  color: var(--form-arrow-color) !important;
  font-size: 16px !important;
}
.customCalendar > div {
  box-shadow: 0 0 80px 0 rgba(0, 0, 0, 0.2);
}

div.customPhoneInput > div > i {
  color: var(--form-arrow-color) !important;
  font-size: 16px !important;
}

.meetingForm textarea {
  resize: vertical;
}

.disclaimerButton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-family: "Inter", sans-serif;
}

.disclaimerCheckBox > div > div > label span {
  border-radius: 25%;
  border: solid 1px var(--primary-border-focus-color) !important;
}

.disclaimer {
  font-size: 14px;
  line-height: 1.33;
  font-weight: 400;
  color: var(--secondary-text-color);
  font-family: "Inter", sans-serif;
}

div.disclaimerRow {
  flex-direction: row;
}

.disclaimer i {
  margin-left: 0.5rem;
  padding-top: 1rem;
  cursor: pointer;
}

.disclaimerCheckBox {
  max-width: fit-content;
  margin-right: 0;
}

.expContent {
  font-size: 12px;
  line-height: 1.33;
  padding-top: 10px;
}

.expContent ul {
  margin-top: 8px;
  list-style-type: disc;
}

.expContent li {
  margin-left: 16px;
}

.expContent a {
  color: var(--secondary-color-palette);
  font-size: 12px;
}

.cta {
  margin-top: 12px;
  text-align: left;
  width: 119px;
}

.meetingForm .cta button {
  text-transform: uppercase;
  min-width: 150px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.3;
  padding: 6px 16px;
  font-family: "CornerDisplay", sans-serif;
  border: solid 2px var(--primary-cta-color) !important;
  background-color: var(--primary-cta-color) !important;
  border-radius: 8px;
}
.errorSubmit {
  color: var(--form-text-error-color);
  display: block;
  margin-top: 20px;
}

div.containerError {
  text-align: center;
}

.messageSubmit {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

@media screen and (min-width: 561px) {
  .customInputCalendar i {
    margin-left: 155px !important;
  }
}

@media screen and (min-width: 769px) {
  .meetingTitle {
    justify-content: center;
    font-size: 52px;
  }

  .customInputCalendar i {
    margin-left: 0px !important;
  }

  .customRadio {
    flex-direction: row;
    flex-wrap: wrap;
  }

  div.customRadio label {
    flex: 0 1 50%;
    min-height: 56px !important;
    margin-top: -1px;
  }

  div.customRadio label:first-child {
    border-bottom-left-radius: 0 !important;
  }

  div.customRadio label:nth-child(2) {
    border-top-right-radius: 4px !important;
  }

  div.customRadio label:nth-child(3) {
    border-bottom-left-radius: 4px !important;
  }

  div.customRadio label:last-child {
    border-top-right-radius: 0 !important;
  }
}

@media screen and (min-width: 993px) {
  .meetingTitle {
    font-size: 64px;
  }

  .meetingSubTitle {
    font-size: 24px;
  }
}

@media screen and (min-width: 1280px) {
  .action {
    flex: 1 0 600px;
  }

  div.customFieldRow {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
